<template>
  <Slider
    class="stage-slider"
    :autoplay="7000"
    variant="transparent"
  >
    <template
      v-for="(entry, i) in stageSlidesData"
      :key="i"
    >
      <StageSlide
        :slide-data="entry"
        :lazy-loading="i > 0"
        class="stage-slider__slider-item"
        :class="entry.customClass"
        :data-slider-styles="entry.customStyle"
      />
    </template>
  </Slider>
</template>

<script lang="ts" setup>
import { Slider } from '@i22team/td-longtail-vue-components';
import StageSlide, { type StageSlideComponentProps } from '~/components/stage-slide.vue';

export type StageSliderComponentProps = {
  stageSlidesData: StageSlideComponentProps['slideData'][];
};

withDefaults(defineProps<StageSliderComponentProps>(), {});
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.stage-slider {
  @include mq(false, $mq-sm - 1) {
    :deep(.slider__pagination) {
      display: none;
    }
  }
}
</style>
